export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Error al iniciar",
    "StaticConfigLoader.caption.init": "Iniciar",
    "StaticConfigLoader.text.init": "Iniciando aplicación...",
    "StaticConfigLoader.error.settings": "No se ha podido cargar la configuración del sitio",
    "StaticConfigLoader.error.circuits": "No se ha podido cargar la configuración de los servicios",
    //app
    "Legal.Localization": "es",
    "AchievementApp.Navbar.storeTitle": "Tienda",
    "AchievementApp.Navbar.supportTitle": "Soporte",
    "Legal.TermsConditions": "Términos y Condiciones",
    "Legal.TermsService": "Condiciones de Uso",
    "Legal.PrivacyPolicy": "Política de Privacidad",
    "Legal.CookiesPolicy": "Ajustes de cookies",
    "Legal.Copyright": "Todas las marcas comerciales, logotipos y nombres de marcas son propiedad de sus respectivos propietarios.",
    "AchievementApp.Navbar.achievement": "Logros personales",
    "AchievementApp.Navbar.userAchievement": "Logros de usuario",
    "AchievementApp.Navbar.settingsLink": "Configuración",
    "AchievementApp.Navbar.profileLink": "Perfil",
    "AchievementApp.Navbar.reloginLink": "Reiniciar sesión o cambiar cuenta",
    "AchievementApp.Navbar.pageTitlePrew": "Logros de ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Completado",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtrar por títulos",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Mis amigos",
    "UserFriendsList.heading.showMore": "Mostrar más",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Tienes que configurar la autorización en dos pasos",
    "LimitedAccountPanel.2step.link": "Más información sobre la autorización en dos pasos",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Tienes que confirmar tu dirección de correo electrónico",
    "LimitedAccountPanel.email.link": "Pasar al perfil",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Tu cuenta está limitada debido a:",
    "LimitedAccountPanel.conclusion": "Tras cambiar la configuración de seguridad, deberías cerrar la sesión y luego iniciar sesión para que los cambios surtan efecto",
    "LimitedAccountPanel.relogin": "Reiniciar sesión",
    "EmailVerificationStateIcon.success": "Cuenta confirmada, correo electrónico verificado",
    "EmailVerificationStateIcon.warning": "Cuenta no confirmada, correo electrónico no verificado",
    "EmailVerificationStateIcon.danger": "Cuenta no confirmada, verificación de correo electrónico NECESARIA",
    "TwoFactorStateIcon.success": "Cuenta segura con autorización en dos pasos",
    "TwoFactorStateIcon.warning": "Cuenta no segura, autorización en dos pasos desactivada",
    "TwoFactorStateIcon.danger": "Autorización en dos pasos NECESARIA",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Guardar configuración",
    "UserSettingDialog.settings": "Configuración",
    "UserSettingDialog.userSettings": "Configuración de usuario",
    "UserSettingDialog.language": "Idioma",
    "UserSettingDialog.privacy": "Privacidad",
    "UserSettingDialog.allUsers": "Todos los usuarios",
    "UserSettingDialog.friendsOnly": "Solo amigos",
    "UserSettingDialog.onlyMe": "Solo yo",
    "UserSettingDialog.whoCanView": "Quién puede ver mis logros",
    //unlockProgress
    "ViewUnlockProgress.of": " de ",
    "ViewUnlockProgress.achievCompleted": " logros completados",
    "ViewUnlockProgress.myUnlock": "Mis logros",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Busca el apodo aquí",
    "ViewItemSearch.label.search": "Buscar usuarios",
    "ViewItemSearch.resultNotFound": "Usuario no encontrado",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Logro",
    "ViewItemSearch.stub.empty": "Sin logros",
    "ViewItemSearch.stub.emptyCompare_1": "El usuario ",
    "ViewItemSearch.stub.emptyCompare_2": " no tiene logros en este juego",
    "ViewItemSearch.limitedAccess": "El acceso a los logros del usuario seleccionado está limitado",
    "ViewItemSearch.heading.selectGame": "Selecciona un juego de la lista",
    "ViewItemSearch.globalstat.opened": "desbloqueado por un ",
    "ViewItemSearch.globalstat.ofGamers": "% de los jugadores",
    //authentication
    "NotAllowedMessage.caption": "No permitido",
    "NotAllowedMessage.body.h1": "El acceso a los logros",
    "NotAllowedMessage.body.h3": "no está permitido para tu cuenta en este momento",
    "NotAllowedMessage.relogin": "Cambiar cuenta",
    "LandingMessage.caption": "Autenticación",
    "LandingMessage.body": "Terminando la carga...",
    "TokenExpiredMessage.caption": "Autenticación caducada",
    "TokenExpiredMessage.body.h3": "Para continuar, tienes que volver a iniciar sesión",
    "TokenExpiredMessage.relogin": "Reiniciar sesión",
    "AuthErrorMessage.caption": "Error de autenticación",
    "AuthErrorMessage.body.h1": "No se ha podido comprobar la autenticación",
    "AuthErrorMessage.body.code": "Código",
    "AuthErrorMessage.body.desc": "Para continuar, tienes que volver a iniciar sesión",
    "AuthErrorMessage.relogin": "Reiniciar sesión",
    "AuthorizationRequiredMessage.caption": "Autenticación necesaria",
    "AuthorizationRequiredMessage.body.h3.1": "Vas a entrar en",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Tienes que estar autorizado para continuar",
    "AuthorizationRequiredMessage.login": "Iniciar sesión con Gaijin.Net",
    "CheckingAuthMessage.caption": "Autenticación",
    "CheckingAuthMessage.body": "Comprobando autenticación, espera un momento",
    "AuthorizationRequiredMessageMobile.body.h3.1": "La versión móvil no está disponible temporalmente",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Usa la versión para ordenadores",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Lo sentimos",
}